import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../providers/localStorage.service';

@Injectable({
  providedIn: 'root'
})

export class AutologinGuard implements CanLoad {
	constructor(private router:Router,
				private storage:LocalStorageService) {

}

async canLoad() {
	const token = await this.storage.getToken();
	if (token) {
		this.router.navigateByUrl('/tabs', {replaceUrl: true});
		return false;
	} else {
		return true;
	}
}

}
